// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
  height: 100%;
  margin: 0;
  font-family: Arial, sans-serif;
}

.TumFiyatlar {
  display: flex;
  align-items: center;
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  flex-direction: column;
}

.card {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  flex-direction: row;
  align-self: center;
  margin: 10px;
  word-wrap: break-word;
}

.date-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}

.artisticText {
  font-family: cursive;
  font-size: 16px;
}

.logo {
  width: 220px;
  height: 120px;
  object-fit: contain;
  margin: 10px;
}

.grayText {
  color: rgb(173, 170, 170);
  text-align: center;
  margin-top: 10px;
}

.invoice-table th, .invoice-table td {
  border: 1px solid #f4f2ec;
  text-align: center;
}

.invoice-table {
  margin: 0 auto;
}

.box1 {
  background-color: rgb(244, 244, 244);
}

.box2 {
  background-color: rgb(224, 224, 224);
}
.date-selector {
  margin-bottom: 20px;
}

.date-selector label {
  margin-right: 10px;
}

.date-selector select {
  padding: 5px;
}

/* Media Queries */

@media (max-width: 599px) {
  .card {
    padding: 20px;
  }
  p {
    font-size: 12px;
  }
  img {
    width: 20px;
    height: 20px;
  }
  h1 {
    font-size: 18px;
  }
}

@media (min-width: 600px) and (max-width: 899px) {
  .card {
    padding: 30px;
  }
  p {
    font-size: 15px;
  }
  img {
    width: 25px;
    height: 25px;
  }
  h1 {
    font-size: 20px;
  }
}

@media (min-width: 900px) {
  .card {
    padding: 40px;
  }
  p {
    font-size: 16px;
  }
  img {
    width: 30px;
    height: 30px;
  }
  h1 {
    font-size: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TumFiyatlar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yDAAoD;EACpD,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,kBAAkB;;AAElB;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["body, html {\n  height: 100%;\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n\n.TumFiyatlar {\n  display: flex;\n  align-items: center;\n  height: 100vh;\n  background-image: url('../../assets/background.jpg');\n  background-size: cover;\n  background-position: center;\n  flex-direction: column;\n}\n\n.card {\n  background: white;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  flex-direction: row;\n  align-self: center;\n  margin: 10px;\n  word-wrap: break-word;\n}\n\n.date-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.artisticText {\n  font-family: cursive;\n  font-size: 16px;\n}\n\n.logo {\n  width: 220px;\n  height: 120px;\n  object-fit: contain;\n  margin: 10px;\n}\n\n.grayText {\n  color: rgb(173, 170, 170);\n  text-align: center;\n  margin-top: 10px;\n}\n\n.invoice-table th, .invoice-table td {\n  border: 1px solid #f4f2ec;\n  text-align: center;\n}\n\n.invoice-table {\n  margin: 0 auto;\n}\n\n.box1 {\n  background-color: rgb(244, 244, 244);\n}\n\n.box2 {\n  background-color: rgb(224, 224, 224);\n}\n.date-selector {\n  margin-bottom: 20px;\n}\n\n.date-selector label {\n  margin-right: 10px;\n}\n\n.date-selector select {\n  padding: 5px;\n}\n\n/* Media Queries */\n\n@media (max-width: 599px) {\n  .card {\n    padding: 20px;\n  }\n  p {\n    font-size: 12px;\n  }\n  img {\n    width: 20px;\n    height: 20px;\n  }\n  h1 {\n    font-size: 18px;\n  }\n}\n\n@media (min-width: 600px) and (max-width: 899px) {\n  .card {\n    padding: 30px;\n  }\n  p {\n    font-size: 15px;\n  }\n  img {\n    width: 25px;\n    height: 25px;\n  }\n  h1 {\n    font-size: 20px;\n  }\n}\n\n@media (min-width: 900px) {\n  .card {\n    padding: 40px;\n  }\n  p {\n    font-size: 16px;\n  }\n  img {\n    width: 30px;\n    height: 30px;\n  }\n  h1 {\n    font-size: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
